import { render, staticRenderFns } from "./side-nav_mobile.vue?vue&type=template&id=1dcb832c"
import script from "./side-nav_mobile.vue?vue&type=script&lang=js"
export * from "./side-nav_mobile.vue?vue&type=script&lang=js"
import style0 from "./side-nav_mobile.vue?vue&type=style&index=0&id=1dcb832c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports